import CloseButton from 'components/button-close/close-button';
import StandardButton from 'components/button-standard/standard-button';
import StandardOutlinedButton from 'components/standard-outlined-button/standard-outlined-button';
import React, { ReactNode } from 'react';
import { Modal } from 'reactstrap';
import './modal-action.scss';

interface ModalActionProps {
    title: ReactNode;
    message: ReactNode;
    onClose: () => void;
    onAction: () => void;
    cancelButtonLabel?: string;
    confirmButtonLabel?: string;
    disabled?: boolean;
    icon?: ReactNode;
}

const ModalAction = (props: ModalActionProps) => {
    const { message, onAction, onClose, title, cancelButtonLabel, confirmButtonLabel, disabled, icon } = props;

    return (
        <Modal isOpen>
            <div className="modal-action">
                <article className="modal-action--content">
                    <header className="modal-action--header">
                        <CloseButton onClick={onClose} />
                    </header>
                    <div className="modal-action--action">
                        <div className="modal-action--icon"> {icon} </div>
                        <p className="modal-action--title">{title}</p>
                        {<p className="modal-action--text">{message}</p>}
                    </div>

                    <div className="modal-action--actions">
                        <StandardOutlinedButton label={cancelButtonLabel ?? 'entity.action.cancel'} onClick={onClose} />
                        <StandardButton label={confirmButtonLabel ?? 'entity.action.confirm'} onClick={onAction} disabled={disabled} />
                    </div>
                </article>
            </div>
        </Modal>
    );
};

export default ModalAction;
